import React from "react";
import FormExperience from "./FormExperience";
import AddButton from "./element/AddButton";
import DeleteButton from "./element/DeleteButton";

function FormExperiences({ experiences, id, updateData, addData, removeData }) {
  function handleAdd() {
    addData({ category: "experience", mainId: id });
  }
  function handleDelete() {
    removeData({ category: "formExperience", mainId: id });
  }
  return (
    <>
      <div className="my-4">
        {" "}
        <div className="flex items-center pb-2 gap-4">
          <div className="text-base font-semibold">Experience</div>{" "}
          <DeleteButton handleDelete={handleDelete} />
        </div>
        <div className="input-container">
          {experiences.items.map((experience, index) => {
            return (
              <FormExperience
                key={experience.id}
                itemId={index}
                experience={experience}
                experienceId={id}
                updateData={updateData}
                addData={addData}
                removeData={removeData}
              />
            );
          })}
        </div>
        <AddButton handleAdd={handleAdd} text={"+ experience Item"} />
      </div>
    </>
  );
}

export default FormExperiences;
